import React from 'react';
import { FileInfoBO, Permission } from '../../model/BO/FileBO';
import { RequestStatus } from '../../model/BO/CommonBO';
import Background from '../../assets/background_mobile@2x.png';
import NoAuth from '../../assets/no_auth_mobile@2x.png';
import './index.scss';
import { getFileTypeByName, bytesToSize, getLengthValidateFileName } from '../../utils/FileUtil';
import { expireMap } from '../../service/FileService';

interface PublicShareMobileProps {
  fileInfo: FileInfoBO | null;
  noPermission: boolean;
  fetchStatus: RequestStatus;
  allowPreview: boolean;
  handleRetry: () => void;
  handleDownload: () => void;
  handlePreview: () => void;
}

export default class PublicShareMobile extends React.PureComponent<PublicShareMobileProps> {
  public handleTouchStart() {}

  public renderContent() {
    const { fileInfo, allowPreview, noPermission } = this.props;
    if (noPermission) {
      return <img src={NoAuth} className="bg center-content" alt="无权限" title="无权限" />;
    }
    if (!fileInfo) {
      return null;
    }
    if (fileInfo.expire || !fileInfo.shareOpen) {
      return <img src={NoAuth} className="bg center-content" alt="无权限" title="无权限" />;
    }
    const type = getFileTypeByName(fileInfo.fileName);
    const fileName = getLengthValidateFileName(fileInfo.fileName, 42);
    return (
      <div>
        <img src={Background} className="bg center-content" title="背景" alt="背景" />
        <div className="file-info center-content ">
          <img
            className="file-type"
            src={require(`../../assets/fileIcon/file_type_${type}.svg`)}
            alt={type}
            title={type}
          />
          <div className="title" title={fileName}>
            {fileName}
          </div>
          <div className="sub-info">
            <span>
              分享者:
              <span className="share-name" title={fileInfo.shareName}>
                {fileInfo.shareName}
              </span>
            </span>
            <span className="expire-time">有效期: {expireMap.get(fileInfo.expireType)}</span>
            <span>文件大小: {bytesToSize(fileInfo.size)}</span>
          </div>
          <div>
            {allowPreview ? (
              <button
                className="btn btn-primary preview-btn"
                onTouchStart={this.handleTouchStart}
                onClick={this.props.handlePreview}
              >
                打开
              </button>
            ) : null}
            {fileInfo.permission === Permission.DOWNLOAD ||
            fileInfo.permission === Permission.EDIT ? (
              <button
                className="btn btn-default"
                onTouchStart={this.handleTouchStart}
                onClick={this.props.handleDownload}
              >
                下载
              </button>
            ) : null}
          </div>
          <div></div>
        </div>
      </div>
    );
  }

  render() {
    const { fetchStatus } = this.props;
    return (
      <div className="share-container share-mobile-container">
        {fetchStatus === RequestStatus.FAILED ? (
          <div className="error">
            加载失败，
            <a className="retry" onClick={this.props.handleRetry}>
              请重试
            </a>
          </div>
        ) : fetchStatus === RequestStatus.PENDING ? (
          <div className="loading">加载中...</div>
        ) : (
          this.renderContent()
        )}
      </div>
    );
  }
}
